export const setSettings = (answerChoicesMax = 4, answerChoicesUpTo = 4, requiredAnswersPerQuestion = 1, rotate = false, quiz = false, inline = false, references = false, rVoice = false, eVoice = false, rCode='ru-RU', eCode='en-US') => ({ answerChoicesMax, answerChoicesUpTo, requiredAnswersPerQuestion, rotate, quiz, inline, references, rVoice, eVoice, rCode, eCode });

export  function doVoice(val, lang) {
    var synth = window.speechSynthesis;
    var utterThis = new SpeechSynthesisUtterance(val);
    utterThis.lang = lang;
    utterThis.rate = 0.8;
    synth.speak(utterThis);
  }

export function getQuestions(settings) {
    var questions = [];
    let lastId = 0;
    const createQuestion = (key, val, runCount = 0, errors = 0, completed = false, choices = []) => ({ id: ++lastId, rKey: key, eVal: val, key, val, runCount, errors, completed, choices });

    //console.log(document.getElementById('quizdata').value);
    const lines = document.getElementById('quizdata').value.split('\n');
    for (var i = 0; i < lines.length; i++) {
        lines[i] = lines[i].replace(/\t/g, ' ').trim();
        if (lines[i] == "")
            continue;
        lines[i] = lines[i].replace(/\s\s+/g, ' ');
        let k, v, kNumcheck = "";
        if (lines[i].indexOf("|") > -1) {
            k = lines[i].substr(0, lines[i].indexOf('|'));
            v = lines[i].substr(lines[i].indexOf('|') + 1);
        } else {
            k = lines[i].substr(0, lines[i].indexOf(' '));
            v = lines[i].substr(lines[i].indexOf(' ') + 1);
        }
        if (k.trim() == "" || v.trim() == "")
            continue;

        kNumcheck = k.substr(0, k.indexOf(' '));
        // console.log(kNumcheck);
        if (Number.isInteger(parseInt(kNumcheck, 10))) {
            k = k.substr(k.indexOf(' ') + 1);
        }

        questions.push(createQuestion(k.trim(), v.trim()));
    }

    let uniqueKeys = Array.from(new Set(questions.map(i => i.key))).length;
    settings.answerChoicesMax = Array.from(new Set(questions.map(i => i.val))).length;
    if (settings.answerChoicesMax < 2 || uniqueKeys < 2) {
        document.getElementById('quizdata').value = "Error: Quiz needs to have at least two uniques questions and two unique answers.";
        return null;
    }
    if (settings.answerChoicesMax > 10)
        settings.answerChoicesMax = 10;
    if (settings.answerChoicesUpTo > settings.answerChoicesMax)
        settings.answerChoicesUpTo = settings.answerChoicesMax;

        // settings.rVoice = checkLanguage(settings.rCode);
        // if (!settings.rVoice){
        //   settings.rCode = settings.rCode.replace("-","_")
        //   settings.rVoice = checkLanguage(settings.rCode);
        // }
        // settings.eVoice = checkLanguage(settings.eCode);
        // if (!settings.eVoice){
        //   settings.eCode = settings.eCode.replace("-","_")
        //   settings.eVoice = checkLanguage(settings.eCode);
        // }

    document.getElementById('quizdata').style.display = "none";
    document.getElementById('quizLoading').style.display = "none";
    
    //settings.total = questions.length;
    if (settings.rotate) {
        return questions.map(o => {
            return { id: o.id, rKey: o.rKey, eVal: o.eVal, key: o.val, val: o.key, runCount: o.runCount, errors: o.errors, completed: o.completed, choices: o.choices };
        });
    };

    return questions;
};

export function getNextQuestion(data, settings) {
    const remainingQuestions = data.filter(i => i.completed == false);
    if (remainingQuestions.length == 0) return null;
    const questionToReturn =
        remainingQuestions[Math.floor(Math.random() * remainingQuestions.length)];
    questionToReturn.choices = BuildAnswers(
        questionToReturn.key,
        questionToReturn.val,
        data,
        settings.answerChoicesUpTo
    );
    return questionToReturn;
}



function BuildAnswers(key, val, ar, upTo) {
    let copyAr = ar.filter(i => i.key != key);
    let retAnswers = [val];
    copyAr = shuffleArray(copyAr);
    for (var i = 0; i < copyAr.length; i++) {
        if (!retAnswers.includes(copyAr[i].val)) {
            retAnswers.push(copyAr[i].val);
        }
    }
    // console.info("upTo---" + upTo)
    retAnswers = retAnswers.slice(0, upTo);
    retAnswers = shuffleArray(retAnswers);
    return retAnswers;
}

function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function sleepTime(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function checkLanguage(lang) {
    var voices = speechSynthesis.getVoices();
    var voice = voices.filter(function (voice) {
        return voice.lang == lang;
    });
    // alert(voice.length)
    if (voice.length > 0)
        return true;
    return false;
}
